import { ClientTicketRefundInitiator, ClientTicketRefundStatus, IClientTicketFull } from '@bustickus/models-client';
import { Button, Flex, Message } from 'components';
import { useState } from 'react';
import { SpoilerCard } from 'shared/components';
import * as bi from 'react-bootstrap-icons';
import { CreateRefundModal } from './components';
import { DataRow } from '../data-row';

interface IProps {
  ticket: IClientTicketFull;
  onRefund: () => void;
}

function RefundCard(props: IProps) {
  const [open, setOpen] = useState<boolean>(false);
  const [refundModal, setRefundModal] = useState<boolean>(false);

  const handleRefundModalClose = (changed: boolean) => {
    setRefundModal(false);

    if (changed) {
      props.onRefund();
    }
  };

  return (
    <>
      {refundModal && (
        <CreateRefundModal
          onClose={handleRefundModalClose}
          ticketId={props.ticket.id}
        />
      )}
      <SpoilerCard
        title='Возврат средств'
        open={open}
        onOpenClick={() => setOpen(!open)}
      >
        {props.ticket.refund == null && (
          <Flex
            direction='column'
            gap={10}
          >
            <Message type='info'>
              Если вы столкнулись с некачественной услугой или купили билет по ошибке, вы можете запросить возврат
              средств за него. <br />
              Заявка на возврат средств будет отправлена перевозчику.
              <br />
              <br />
              <b>Внимание!</b> При одобрении заявки будет возвращена только непосредственная стоимость билета, комиссия
              сервиса возвращена не будет.
            </Message>

            {!props.ticket.canRefund && <Message type='error'>Возврат средств недоступен для этого билета</Message>}

            <Button
              color='red'
              size='small'
              disabled={!props.ticket.canRefund}
              onClick={() => setRefundModal(true)}
            >
              <Flex
                alignItems='center'
                justifyContent='center'
                gap={5}
              >
                <bi.Coin />
                Запросить возврат
              </Flex>
            </Button>
          </Flex>
        )}
        {props.ticket.refund != null && (
          <Flex
            direction='column'
            gap={5}
          >
            <DataRow
              icon={<bi.Feather />}
              title='Статус:'
              value={`${getStatusText(props.ticket.refund.status)}`}
            />
            <DataRow
              icon={<bi.Person />}
              title='Инициатор:'
              value={`${getInitiatorText(props.ticket.refund.initiator)}`}
            />

            {props.ticket.refund.reason.length > 0 && (
              <Message
                type='info'
                title='Вложенное сообщение'
              >
                {props.ticket.refund.reason}
              </Message>
            )}
          </Flex>
        )}
      </SpoilerCard>
    </>
  );
}

function getInitiatorText(initiator: ClientTicketRefundInitiator): string {
  if (initiator === 'client') {
    return 'Покупатель';
  }

  if (initiator === 'carrier') {
    return 'Перевозчик';
  }

  if (initiator === 'admin') {
    return 'Администратор';
  }

  return status;
}

function getStatusText(status: ClientTicketRefundStatus): string {
  if (status === 'approved') {
    return 'Одобрен';
  }

  if (status === 'declined') {
    return 'Отклонён';
  }

  if (status === 'pending') {
    return 'Рассматривается...';
  }

  return status;
}

export default RefundCard;
